"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('return', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("polyline", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(12.363961, 14.363961) rotate(45.000000) translate(-12.363961, -14.363961) ",
    points: "7.86396103 9.86396103 7.86396103 18.863961 16.863961 18.863961"
  }), _react.default.createElement("path", {
    d: "M6,14.363961 L28.1722323,14.363961 C35.3362845,14.363961 41.22076,20.0233725 41.5,27.1819805 C41.7655807,33.9904186 36.4615469,39.7250439 29.6531088,39.9906247 C29.4928928,39.9968743 29.3325702,40 29.1722323,40 L12,40",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }))));
});

exports.default = _default;